module.exports = __webpack_public_path__ + "img/Slide17.33696e61.png";